import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@intranet/shared/shared.module';
import { OverlayModule } from '@intranet/components/overlay/overlay.module';
import { DialogModule } from '@intranet/components/dialog/dialog.module';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';
import { PipesModule } from '@intranet/core/pipes/pipes.module';
import { ActionModule } from '@intranet/modules/actions/action.module';
import { TabsModule } from '@intranet/components/tabs/tabs.module';

import { JobsComponent } from './jobs.component';
import { JobsDetailComponent } from './detail/jobs-detail.component';
import { JobsManageComponent } from './manage/jobs-manage.component';
import { JobsListingComponent } from './listing/jobs-listing.component';
import { JobsTableComponent } from './listing/jobs-table/jobs-table.component';
import { JobsSearchComponent } from './listing/search/jobs-search.component';
import { jobRoutes } from './jobs.routes';
import { JobFinanceInfoComponent } from './detail/finance-info/job-finance-info.component';
import { JobFinanceMarginsComponent } from './detail/job-finance-margins/job-finance-margins.component';
import { MatCurrencyFormatModule } from 'mat-currency-format';
import { Currency } from '../finance';
import { TogglModule } from '../toggl';
import { TimerStartButtonModule } from '@intranet/modules/timer/timer-start-button/timer-start-button.module';
import { JobJiraLinksComponent } from './detail/job-finance-margins/job-jira-links/job-jira-links.component';
import { JobValueComponent } from './detail/value/job-value.component';
import { JobValueLinkJobComponent } from './detail/value/job-value-link-job.component';
import { JobsCopyComponent } from './copy/jobs-copy.component';
import { ClientDashboardSummaryComponent } from './listing/client-dashboard-summary/client-dashboard-summary.component';
import { QuillModule } from 'ngx-quill';
import { MarginBarModule } from '@intranet/components/margin-bar/margin-bar.module';
import { AvatarModule } from '@intranet/components/avatar';
import { UserPickerModule } from '@intranet/components/user-picker';
import { ClientSearchModule } from '@intranet/components/client-search';
import { MatMenuModule }    from '@angular/material/menu';
import { MatButtonModule }  from '@angular/material/button';
import { MatIconModule }    from '@angular/material/icon';
import { MatCheckboxModule }from '@angular/material/checkbox';


@NgModule({
    declarations: [
        JobsDetailComponent,
        JobsManageComponent,
        JobsComponent,
        JobsListingComponent,
        JobsTableComponent,
        JobsSearchComponent,
        JobFinanceInfoComponent,
        JobFinanceMarginsComponent,
        JobJiraLinksComponent,
        JobValueComponent,
        JobValueLinkJobComponent,
        JobsCopyComponent,
        ClientDashboardSummaryComponent,
    ],
    imports: [
        RouterModule.forChild(jobRoutes),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCurrencyFormatModule,
        DialogModule,
        PipesModule,
        ActionModule,
        SharedModule,
        TabsModule,
        OverlayModule,
        TooltipModule,
        TogglModule,
        TimerStartButtonModule,
        QuillModule.forRoot(),
        MarginBarModule,
        AvatarModule,
        UserPickerModule,
        ClientSearchModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
    ],
    providers: [CurrencyPipe],
    exports: [JobsManageComponent, JobsListingComponent, JobsCopyComponent, JobValueComponent, ClientDashboardSummaryComponent ],
})
export class JobsModule {}
